import { useState, useEffect, useRef } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { showCustomToast } from "../../../Components/shared/customToast";
import { notificationTypeIcons, formatToDayTime, normalizeTypeName } from "../../../Data/notifications"
import { markNotificationAsRead } from "../../../Data/Functions/index"
import { trackClick } from "../../../Data/notificationStatsQueue"
import "./index.css"


const NotificationItem = ({ notification, userId, onMarkedAsRead }) => {

    const [hasMarkedRead, setHasMarkedRead] = useState(false);
    const [descriptionState, setDescriptionState] = useState({
        isTruncated: false,
        showFull: false,
        truncationChecked: false
    });
    const itemRef = useRef(null);


    const normalizedType = normalizeTypeName(notification?.type || '');
    const IconComponent = notificationTypeIcons[normalizedType];
    const readStatus = notification?.readStatus || {};
    const isRead = 'isRead' in readStatus ? readStatus.isRead : readStatus.read;
    const hasLink = typeof notification?.link === 'string' && notification.link.trim().length > 0;

    useEffect(() => {
        if (itemRef.current && descriptionState.truncationChecked) {
            itemRef.current.setAttribute('data-truncated', descriptionState.isTruncated.toString());
        }
    }, [descriptionState.isTruncated, descriptionState.truncationChecked]);

    const handleMarkAsRead = async (e) => {
        e.preventDefault();
        trackClick(notification?.id);
        if (!isRead && !hasMarkedRead) {
            setHasMarkedRead(true);
            onMarkedAsRead?.();
            
            try {
                await markNotificationAsRead(notification?.id, userId);
                window.open(notification.link, "_blank");
            } catch (error) {
                setHasMarkedRead(false);
                console.error("Failed to mark notification as read:", error);
                showCustomToast("Failed to mark as read", "error");
                window.open(notification.link, "_blank");
            }
        } else {
            window.open(notification.link, "_blank");
        }
    };

    const handleClickLongDescriptionNotification = async (e) => {
        if (descriptionState.isTruncated) {
            e.stopPropagation();

            setDescriptionState(prev => ({
                ...prev,
                showFull: !prev.showFull
            }));

            trackClick(notification?.id);
            if (!isRead && !hasMarkedRead) {
                setHasMarkedRead(true);
                onMarkedAsRead?.();
                
                try {
                    const data = await markNotificationAsRead(notification?.id, userId);
                    if (data?.success) {
                        showCustomToast("Notification marked as read", "success");
                    } else {
                        setHasMarkedRead(false);
                        showCustomToast("Error marking notification as read", "error");
                    }
                } catch (error) {
                    setHasMarkedRead(false);
                    console.log('Error marking notification as read', error);
                    showCustomToast("Error marking notification as read", "error");
                }
            }
        }
    };

    const effectiveIsRead = isRead || hasMarkedRead;

    return (
        <div
            ref={itemRef}
            data-notification-id={notification.id}
            data-truncated="false"
            className={`notificationItemContainer ${effectiveIsRead ? 'read' : 'unread'}`}
        >
            <div>
                {IconComponent && (
                    <IconComponent className="w-10 h-10" />
                )}
            </div>
            <div className='notificationContent w-[95%]'>
                <div className='flex flex-col gap-2 w-[95%]'>
                    <span className={`notificationTitle`}>
                        {notification.title || 'New Title'}
                    </span>
                    <span className="notificationDescription">
                        {!descriptionState.showFull ? (
                            <div
                                onClick={handleClickLongDescriptionNotification}
                                className={`sm:w-[350px] w-full ${descriptionState.isTruncated ? 'cursor-pointer' : ''}`}
                            >
                                <TruncateMarkup
                                    lines={2}
                                    onTruncate={(wasTruncated) => {
                                        setDescriptionState(prev => ({
                                            ...prev,
                                            isTruncated: wasTruncated,
                                            truncationChecked: true
                                        }));
                                    }}
                                >
                                    <span>{notification.description || 'lorem'}</span>
                                </TruncateMarkup>
                            </div>
                        ) : (
                            <div
                                className={`sm:w-[350px] w-full ${descriptionState.isTruncated ? 'cursor-pointer' : ''}`}
                                onClick={handleClickLongDescriptionNotification}
                                style={{ 
                                    whiteSpace: 'normal', 
                                    wordWrap: 'break-word', 
                                    overflowWrap: 'break-word' 
                                }}
                            >
                                {notification.description}
                            </div>
                        )}
                    </span>
                </div>
                <div className="flex items-center justify-between w-[95%]">
                    <div className='notificationDotTime'>
                        <span className={`notificationDot ${effectiveIsRead ? 'read' : 'unread'}`}></span>
                        <span className='notificationTime'>
                            {formatToDayTime(
                                notification?.isShedule
                                    ? notification?.sheduledDateTime
                                    : notification?.createdAt
                            ) || 'Monday 10:35am'}
                        </span>
                    </div>
                    {hasLink && (
                        <a
                            href={notification.link}
                            onClick={handleMarkAsRead}
                            className="notificationLink"
                        >
                            Read More
                        </a>
                    )}
                </div>
            </div>
        </div>
    )
};
export default NotificationItem;
